import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import constants from '@/app-configs/constants'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/cases/Cases.vue'),
      meta: {
        pageTitle: 'DEBTIA_MY_CASES',
        breadcrumb: [
          {
            text: 'DEBTIA_MY_CASES',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/cases/details/:id',
      name: 'case-details',
      component: () => import('@/views/cases/CaseDetails.vue'),
      meta: {
        pageTitle: 'DEBTIA_CASE_DETAILS',
        breadcrumb: [
          {
            text: 'DEBTIA_MY_CASES',
            to: { name: 'home' },
          },
          {
            text: 'DEBTIA_CASE_DETAILS',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/messages',
      name: 'messages',
      component: () => import('@/views/messages/Messages.vue'),
      meta: {
        pageTitle: 'DEBTIA_MESSAGES',
        breadcrumb: [
          {
            text: 'DEBTIA_MESSAGES',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/documents',
      name: 'documents',
      component: () => import('@/views/documents/Documents.vue'),
      meta: {
        pageTitle: 'DEBTIA_DOCUMENTS',
        breadcrumb: [
          {
            text: 'DEBTIA_DOCUMENTS',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import('@/views/faq/Faq.vue'),
      meta: {
        pageTitle: 'DEBTIA_FAQ',
        breadcrumb: [
          {
            text: 'DEBTIA_FAQ',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/reset-password/:token',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/402/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        pageTitle: 'DEBTIA_PROFILE',
        breadcrumb: [
          {
            text: 'DEBTIA_PROFILE',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  // if (!isLoggedIn) console.log('isLoggedIn', to)
  return next()
})

export default router
